<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    max-width>

    <template v-if="isInitialized && !loadingError">

      <product-info-block :sections="vertriebRechtAktuellSections"
                          title="Recht: aktuell" />

    </template>

  </loading-data-page-container>

</template>


<script>

import ProductInfoBlock from "@/components/productInfo/ProductInfoBlock";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  name: "RechtaktuellPage",
  components: { ProductInfoBlock, LoadingDataPageContainer },
  mixins: [contentLoadingMixin(["VertriebRechtAktuell"])],
  computed: {
    vertriebRechtAktuellSections() {
      const value = this.VertriebRechtAktuell;

      if (!value) {
        return [];
      }

      if (Array.isArray(value)) {
        return value;
      }

      if (Array.isArray(value.sections)) {
        return value.sections;
      }

      return [value];
    }
  }
};
</script>

